import { Box, Button, Card, Typography, styled } from "@mui/material";

export const StyledOrdersContainer = styled(Box)(({ theme, background }) => ({
  background: background
    ? theme.palette.custom.orderCards
    : theme.palette.custom.white,
   
  borderRadius: theme.borderRadius.radius.regular,
  padding: theme.padding.size.large,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
}));
export const StyledBoxOrder = styled(Box)(({ path }) => ({
  margin: path && "25px 0px",
}));
export const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.down("xs")]: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
}));

export const StyledTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const StyledIcon = styled("img")({
  width: "22px",
  height: "22px",
});
export const StyledIconUnion = styled("img")({
  width: "14px",
  height: "14px",
});

export const StyledButton = styled(Button)(({ theme }) => ({
  background: theme.palette.custom.warning,
  color: theme.palette.custom.white,
  textTransform: "none",
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  borderRadius: theme.borderRadius.radius.wallet,
  padding: "8px 16px",
  ":hover": {
    background: theme.palette.custom.hover,
  },
}));

export const StyledOrderCard = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  borderRadius: theme.borderRadius.radius.medium,
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: "180px",
  height: "120px",
  color: theme.palette.custom.white,
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const StyledCardText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
}));

export const StyledCardNumber = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography["3xl"]?.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
}));
export const StyledInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
export const StyledNumber = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography["3xl"]?.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
}));

export const StyledCard = styled(Card)(({ theme, iscardbackground }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: iscardbackground
    ? theme.palette.custom.white
    : theme.palette.custom.orderCards,
  borderRadius: theme.borderRadius.radius.medium,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "25px",
  padding: "19px 24px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
}));

export const StyledIconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const StyledCount = styled(Typography)(({ theme, istest, isdemo }) => ({
  fontWeight: theme.typography.fontWeight.bold,
  fontSize: isdemo
    ? theme.typography.xLarge.fontSize
    : theme.typography?.["5xl"].fontSize,
  color: isdemo
    ? theme.palette.custom.packTestColor
    : istest
      ? theme.palette.custom.packIconColor
      : theme.palette.custom.white,
}));

export const StyledTitle = styled(Typography)(({ theme, istest }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  textAlign: "center",
  color: istest ? theme.palette.custom.white : theme.palette.custom.orderName,
}));

export const StyledCardTitle = styled(Typography)(
  ({ theme, istest, ispath }) => ({
    fontSize: !ispath
      ? theme.typography.regular.fontSize
      : istest
        ? theme.typography.medium.fontSize
        : theme.typography.small.fontSize,
    color: istest ? theme.palette.custom.packColor : theme.palette.custom.white,
    textAlign: "left",
  })
);
